/**
 * @file
 * Simple helpers for the tfal theme.
 */

((Drupal, $, once) => {
  /**
   * Core/Misc behaviours.
   */
  Drupal.behaviors.tfalMisc = {
    attach: function attach() {
      $(".person--staff button").click((e) => {
        $(e.target).closest(".person").toggleClass("show-bio");
      });
    },
  };

  Drupal.behaviors.tfalCounter = {
    attach: function attach() {
      function parseCountValue(value) {
        const clean = String(value).trim();
        const match = clean.match(/^(\d+(?:\.\d+)?)([kKmMbB]?)$/);

        if (!match) {
          return null;
        }

        return {
          number: parseFloat(match[1]),
          suffix: match[2] || "",
          decimals: (match[1].split(".")[1] || "").length,
        };
      }

      function formatCountValue(number, decimals, suffix) {
        return number.toFixed(decimals).replace(/\.0+$/, "") + suffix;
      }

      function animateCount(el, duration = 1600) {
        const targetValue = el.dataset.count;
        const parsed = parseCountValue(targetValue);

        if (!parsed) {
          el.textContent = targetValue;
          return;
        }

        const start = 0;
        const end = parsed.number;
        const startTime = performance.now();

        function update(now) {
          const progress = Math.min((now - startTime) / duration, 1);

          // easeOutCubic
          const eased = 1 - Math.pow(1 - progress, 3);

          const current = start + (end - start) * eased;

          el.textContent = formatCountValue(
            current,
            parsed.decimals,
            parsed.suffix
          );

          if (progress < 1) {
            requestAnimationFrame(update);
          } else {
            el.textContent = formatCountValue(
              end,
              parsed.decimals,
              parsed.suffix
            );
          }
        }

        requestAnimationFrame(update);
      }

      const counters = document.querySelectorAll(".js-countup");

      const observer = new IntersectionObserver(
        (entries, obs) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;

            const el = entry.target;

            if (!el.dataset.counted) {
              el.dataset.counted = "true";
              animateCount(el);
            }

            obs.unobserve(el);
          });
        },
        {
          threshold: 0.4,
        }
      );

      counters.forEach((counter) => observer.observe(counter));
    },
  };
})(Drupal, jQuery, once);
